import { useChartColors } from './theme';

export interface SparklineProps { values: number[]; width?: number; height?: number; }

// A tiny theme-aware trend line for KPI tiles — no axes, no tooltip, no table twin:
// it sits inside a StatTile and only conveys shape. A line needs two points, so with
// fewer than two values it renders an empty (but present) svg.
export default function Sparkline({ values, width = 80, height = 24 }: SparklineProps) {
    const c = useChartColors();

    if (values.length < 2) {
        return <svg viewBox={`0 0 ${width} ${height}`} width={width} height={height} role="img" aria-label="trend sparkline" />;
    }

    const pad = 2;
    const min = Math.min(...values);
    const max = Math.max(...values);
    const span = max - min || 1;
    const plotW = width - pad * 2;
    const plotH = height - pad * 2;
    const step = plotW / (values.length - 1);
    const points = values
        .map((v, i) => `${pad + step * i},${pad + plotH * (1 - (v - min) / span)}`)
        .join(' ');
    const lastX = pad + step * (values.length - 1);
    const lastY = pad + plotH * (1 - (values[values.length - 1] - min) / span);

    return (
        <svg viewBox={`0 0 ${width} ${height}`} width={width} height={height} role="img" aria-label="trend sparkline">
            <polyline points={points} fill="none" stroke={c.series[0]} strokeWidth={1.5}
                      strokeLinejoin="round" strokeLinecap="round" />
            <circle cx={lastX} cy={lastY} r={1.8} fill={c.series[0]} />
        </svg>
    );
}
